module.exports = "/_next/static/images/97214f71e2d8d006b4b83e4799495555-msi-lg.png.webp";